import { render, staticRenderFns } from "./best-stop-modal.component.vue?vue&type=template&id=38cb4439&scoped=true"
import script from "./best-stop-modal.component.vue?vue&type=script&lang=js"
export * from "./best-stop-modal.component.vue?vue&type=script&lang=js"
import style0 from "./best-stop-modal.component.vue?vue&type=style&index=0&id=38cb4439&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cb4439",
  null
  
)

export default component.exports